/*
 *  Footer Section
 *    Provides scripts for elements within the footer section.
 *
 *  Version:
 *    1.0.0 - 2019/07/24
 */
import { register, ShopifySection } from './../ShopifySection';
import { Accordion } from './../../objects/accordion/Accordion';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-footer]';
export const FOOTER_MENU_SELECTOR = '[data-footer-menu]';

export class FooterSection extends ShopifySection {
  constructor(container) {
    super(container);

    //Accordion (If it exists)
    let accordionElement = container.find(FOOTER_MENU_SELECTOR);

    if(accordionElement && accordionElement.length) {
      this.accordion = new Accordion(accordionElement);
    }
  }
}

register(CONTAINER_SELECTOR, FooterSection);